import { getMargin as getAliasMargin } from './spacing.alias';
import Transformer from '../transformations/web';
export function getMargin() {
    return getAliasMargin(new Transformer());
}
